export const GET_SEND_OTP = "GET_SEND_OTP";
export const GET_VERIFY_OTP = "GET_VERIFY_OTP";
export const GET_CHOOSE_TYPE = "GET_CHOOSE_TYPE";
export const GET_ROLES = "GET_ROLES";
export const SET_ROLES = "SET_ROLES";
export const GET_USER = "GET_USER";
export const SET_USER = "SET_USER";
export const GET_IMAGE_UPLOAD = "GET_IMAGE_UPLOAD";
export const GET_USER_UPDATE = "GET_USER_UPDATE";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const GET_SUB_CATEGORIES = "GET_SUB_CATEGORIES";
export const SET_SUB_CATEGORIES = "SET_SUB_CATEGORIES";
export const GET_BRANDS = "GET_BRANDS";
export const SET_BRANDS = "SET_BRANDS";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const GET_PRODUCTS_DETAIL = "GET_PRODUCTS_DETAIL";
export const SET_PRODUCTS_DETAIL = "SET_PRODUCTS_DETAIL";
export const GET_ADD_RFQ = "GET_ADD_RFQ";
export const SET_ADD_RFQ = "SET_ADD_RFQ";
export const GET_RFQ = "GET_RFQ";
export const SET_RFQ = "SET_RFQ";
export const GET_DELETE_RFQ = "GET_DELETE_RFQ";
export const SET_DELETE_RFQ = "SET_DELETE_RFQ";
export const GET_UPDATE_RFQ = "GET_UPDATE_RFQ";
export const GET_ADD_PRODUCT = "GET_ADD_PRODUCT";
export const SET_ADD_PRODUCT = "SET_ADD_PRODUCT";
export const GET_DELETE_PRODUCT = "GET_DELETE_PRODUCT";
export const GET_ORDERS = "GET_ORDERS";
export const SET_ORDERS = "SET_ORDERS";
export const GET_STATUS = "GET_STATUS";
export const SET_STATUS = "SET_STATUS";
export const GET_DRAFT_ORDERS = "GET_DRAFT_ORDERS";
export const SET_DRAFT_ORDERS = "SET_DRAFT_ORDERS";
export const GET_ORDERS_DETAIL = "GET_ORDERS_DETAIL";
export const SET_ORDERS_DETAIL = "SET_ORDERS_DETAIL";
export const GET_UPDATE_ORDER = "GET_UPDATE_ORDER";
export const SET_UPDATE_ORDER = "SET_UPDATE_ORDER";
export const GET_FILTERED_PRODUCTS = "GET_FILTERED_PRODUCTS";
export const SET_FILTERED_PRODUCTS = "SET_FILTERED_PRODUCTS";
export const GET_VALUE = "GET_VALUE";
export const SET_VALUE = "SET_VALUE";
export const GET_SWIPPED = "GET_SWIPPED";
export const SET_SWIPPED = "SET_SWIPPED";

